import { default as ErrorIcon } from '../components/ExclamationPoint1';

export default ErrorIcon;
